export const USERS_PREPTALK_RESET = "USERS_RESET";

export const USERS_PREPTALK_LOAD_COACHES_REQUEST = "USERS_PREPTALK_LOAD_COACHES_REQUEST";
export const USERS_PREPTALK_LOAD_COACHES_SUCCESS = "USERS_PREPTALK_LOAD_COACHES_SUCCESS";
export const USERS_PREPTALK_LOAD_COACHES_FAILURE = "USERS_PREPTALK_LOAD_COACHES_FAILURE";

export const USERS_PREPTALK_LOAD_STUDENTS_REQUEST = "USERS_PREPTALK_LOAD_STUDENTS_REQUEST";
export const USERS_PREPTALK_LOAD_STUDENTS_SUCCESS = "USERS_PREPTALK_LOAD_STUDENTS_SUCCESS";
export const USERS_PREPTALK_LOAD_STUDENTS_FAILURE = "USERS_PREPTALK_LOAD_STUDENTS_FAILURE";
